//
//
//
//
//
//
import RankItem from './item';
export default {
  name: 'u8-rank',
  props: {
    ranks: {
      default: function _default() {
        return [];
      }
    },
    max: {
      default: 0
    }
  },
  components: {
    RankItem: RankItem
  }
};